import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { apiRequest } from '../api/client.js';
import { formatLimit } from '../format-limit.js';
import { useBusinessAccounts } from '../business/scope.js';

type Dashboard = {
  readonly businessAccount: { readonly id: string; readonly displayName: string; readonly health: string; readonly messagingLimit: { readonly state: string; readonly maxUniqueRecipients: number | 'unlimited' | null } };
  readonly totals: { readonly contacts: number; readonly campaigns: number; readonly deliveries: number };
};

export const DashboardRoute = () => {
  const { accounts, account, error: accountError } = useBusinessAccounts();
  const accountId = account?.id ?? null;
  const [data, setData] = useState<Dashboard | null>(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    if (accountId === null) return;
    let active = true;
    void apiRequest<{ data: Dashboard }>('/api/v1/business-accounts/' + accountId + '/dashboard')
      .then((response) => { if (active) setData(response.data); })
      .catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, [accountId]);
  if (error || accountError) return <section className="state-panel" role="alert"><h1>Visão geral indisponível</h1><p>Verifique a API e tente novamente.</p></section>;
  if (accounts !== null && account === null) return <section className="state-panel"><h1>Nenhuma BM conectada</h1><p>Conecte uma conta comercial para iniciar a operação.</p></section>;
  if (data === null) return <section className="state-panel" aria-busy="true"><h1>Carregando operação</h1><p>Consultando estado confirmado…</p></section>;
  const healthLabel: Readonly<Record<string, string>> = { connected: 'Conectada', degraded: 'Degradada', blocked: 'Bloqueada' };
  const limit = data.businessAccount.messagingLimit;
  const limitText = formatLimit(limit);
  return <div className="overview">
    <header className="page-heading">
      <div><h1>{data.businessAccount.displayName}</h1><p>Estado operacional confirmado pela última sincronização.</p></div>
      <div className="heading-actions"><span className={'signal signal--' + data.businessAccount.health}>{healthLabel[data.businessAccount.health] ?? data.businessAccount.health}</span><Link className="primary-action" to="/business-accounts">Revisar BMs e números</Link></div>
    </header>
    <section className="limit-band" aria-label="Limite de mensagens"><span>Limite operacional</span><strong>{limitText}</strong></section>
    <dl className="ledger-totals">
      <div><dt>Contatos</dt><dd>{data.totals.contacts}</dd></div>
      <div><dt>Campanhas</dt><dd>{data.totals.campaigns}</dd></div>
      <div><dt>Entregas</dt><dd>{data.totals.deliveries}</dd></div>
    </dl>
  </div>;
};
